import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { WorkCenter, WorkCenterCreate, WorkCenterFilter } from '../data/workCenter';

export function createWorkCenterService(client: AxiosInstance) {
  return createCrudService<WorkCenter, WorkCenterCreate, WorkCenterFilter>(
    client,
    '/manufacturing/WorkCenter',
    'id',
  );
}

export type WorkCenterService = CrudService<WorkCenter, WorkCenterCreate, WorkCenterFilter>;
